import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { apiConstants } from "../../../common/constants";

export const userResetPassword = createAsyncThunk(
    'auth/reset_password',
    async ({ username, current_password, new_password }, { rejectWithValue }) => {
        try {
            // configure header's Content-Type as JSON
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const url = `${apiConstants.BASE_LOCAL}${apiConstants.RESET_PASSWORD}`;

            const { data } = await axios.post(
                url,
                { username, current_password, new_password },
                config
            )
            return data
        } catch (error) {
            // return custom error message from API if any
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);